import { FC } from 'react';

export const GiftPrivacyNotice: FC = function GiftPrivacyNotice() {
  return (
    <div>
      <div className="flex justify-between">
        <h4 className="pb-3 font-bold">개인정보 취급방침에 대한 동의</h4>
      </div>
      <p className="p-4 pt-2 theme-text-8 theme-bg-1">
        <span className="flex h-12 items-center justify-start py-2 text-sm">
          아래 내용을 확인하였으며 결제에 동의합니다.
        </span>
        <span className="block font-bold leading-7 underline">개인정보 취급방침</span>
        <span className="whitespace-pre-line break-keep text-xs leading-[18px]">
          마리화훼(주)는 고객 만족을 위해 상품 품질과 배송 과정에 대해 책임지고
          관리합니다.
        </span>
      </p>
    </div>
  );
};
